import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const PostFinances = {
  Invoices: lazy(() => import('./containers/Invoices_v2/index.tsx')),
  Layout: lazyNamed(() => import('./containers/Invoices_v2/components/InvoicePageHeader.tsx'), 'InvoicePageHeader'),
};

export default PostFinances;
